import { toast } from '@webapp/components/Notification'
import { getMessageFromError } from '@webapp/core/utils/errors/getMessageFromError'
import { useProcurifyIntl } from '@webapp/hooks'
import { type StatementItem } from '@webapp/modules/accounts-payable/entities/StatementItem'
import messages from './messages'
import { useMutateDuplicateStatementItem } from '../../models'

// Hook-only command (ADR-2): no confirmation, no UI — returns the copy so
// the FS inserts it below the original with "JUST CREATED" (BHV-042).
export const useDuplicateStatementItemPresenter = () => {
  const intl = useProcurifyIntl()
  const { duplicateStatementItem, isDuplicating } =
    useMutateDuplicateStatementItem()

  const duplicate = async (item: StatementItem): Promise<StatementItem> => {
    try {
      return await duplicateStatementItem(item)
    } catch (error) {
      toast.error({
        title: intl.formatMessage(messages.errorTitle),
        children:
          getMessageFromError(error) ??
          intl.formatMessage(messages.genericErrorMessage),
      })
      throw error
    }
  }

  return {
    commands: {
      duplicate,
    },
    states: {
      isDuplicating,
    },
  }
}
